import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dokumentService from "../../services/dokument.service";
import DokumentsListKorisnik from "./DokumentListKorisnik";

import { Row, Col, Button, Space, Dropdown, Menu } from "antd";
import SearchBar from "../../components/SearchBar";
import {
  TableOutlined,
  MenuOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import DokumentCardsKorisnik from "./DokumentCardsKorisnik";
import "./DokumentsPageKorisnik.css";
import Background from "../../components/Background4";
import kategorijaDokumentaService from "../../services/kategorijaDokumenta.service";

function DokumentsPageKorisnik() {
  const [dokumenti, setDokumenti] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const [isListView, setListView] = useState(true);
  const [kategorijaDokumenta, setKategorijaDokumenta] = useState(null);
  const [sortCriteria, setSortCriteria] = useState("datumDodavanja");
  const [sortOrder, setSortOrder] = useState("asc");
  const { kategorijaDokumentaId } = useParams();

  const fetchDokumenti = useCallback(async () => {
    try {
      let result;
      if (kategorijaDokumentaId) {
        let kategorija = await kategorijaDokumentaService.getById(
          kategorijaDokumentaId
        );
        setKategorijaDokumenta(kategorija.data);
        result = await dokumentService.getDokumentiByKategorijaId(
          kategorijaDokumentaId
        );
      } else {
        result = await dokumentService.getAll();
      }
      setDokumenti(result.data);
    } catch (error) {}
  }, [kategorijaDokumentaId]);

  useEffect(() => {
    fetchDokumenti();
  }, [fetchDokumenti]);

  const sortArticles = (articles) => {
    return articles.sort((a, b) => {
      let comparison = 0;
      if (sortCriteria === "datumDodavanja") {
        comparison = new Date(a.datumDodavanja) - new Date(b.datumDodavanja);
      } else if (sortCriteria === "naziv") {
        comparison = a.naziv.localeCompare(b.naziv);
      } else if (sortCriteria === "autor") {
        comparison = a.autor.localeCompare(b.autor);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });
  };

  const filtriraniDokumenti = dokumenti.filter((dokument) =>
    dokument.naziv.toLowerCase().includes(searchTitle.toLowerCase())
  );

  const sortedDokumenti = sortArticles([...filtriraniDokumenti]);

  const sortMenu = (
    <Menu onClick={(e) => setSortCriteria(e.key)}>
      <Menu.Item key="datumDodavanja">Datum Objave</Menu.Item>
      <Menu.Item key="naziv">Naziv</Menu.Item>
      <Menu.Item key="autor">Autor</Menu.Item>
    </Menu>
  );
  return (
    <div>
      <Background />
      <div className="docs-border">
        <div className="docs-container">
          <Row justify="center" align="middle" style={{ width: "90%" }}>
            <Col span={24}>
              <div className="page-title-and-search">
                {kategorijaDokumenta && (
                  <h1 className="page-title">{kategorijaDokumenta.naziv}</h1>
                )}
                <SearchBar
                  searchTitle={searchTitle}
                  setSearchTitle={setSearchTitle}
                />
              </div>
            </Col>
          </Row>

          <Row align="middle" style={{ width: "90%" }}>
            <Col className="document-view-right">
              <Space>
                <Button
                  icon={isListView ? <TableOutlined /> : <MenuOutlined />}
                  onClick={() => setListView(!isListView)}
                />
                <Button
                  onClick={() =>
                    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                  }
                >
                  {sortOrder === "asc" ? <UpOutlined /> : <DownOutlined />}
                </Button>
                <Dropdown overlay={sortMenu} trigger={["click"]}>
                  <Button>
                    Sortiraj
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>

          <div className="dokument-list-div">
            {isListView ? (
              <DokumentsListKorisnik dokumenti={sortedDokumenti} />
            ) : (
              <DokumentCardsKorisnik dokumenti={sortedDokumenti} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DokumentsPageKorisnik;
